import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SchoolCoursesService } from '@digilize/language-school/data';
import { Exercise } from '@digilize/language-school/definitions';
import { ShopQuizzesApiService } from '@digilize/shared/data/services/src';
import { QuizSessionAnswerRequest, QuizSessionState } from '@digilize/shared/definitions/src';
import { BehaviorSubject, filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExercisesService {
  private _quiz = new BehaviorSubject<QuizSessionState>(null);
  quiz$ = this._quiz.asObservable().pipe(filter((value) => !!value));
  get quiz() {
    return this._quiz.value;
  }

  set quiz(quiz: QuizSessionState) {
    this._quiz.next(quiz);
  }

  private _exercise = new BehaviorSubject<Exercise>(null);
  exercise$ = this._exercise.asObservable().pipe(filter((value) => !!value));
  get exercise() {
    return this._exercise.value;
  }
  set exercise(exercise: Exercise) {
    this._exercise.next(exercise);
  }

  constructor(
    private shopQuizzesApiService: ShopQuizzesApiService,
    private router: Router,
    private route: ActivatedRoute,
    private schoolCoursesService: SchoolCoursesService
  ) {}

  play(exercise: Exercise, lessonId: string, fromStart = false, cb?: Function) {
    const params: QuizSessionAnswerRequest = {
      shop_quiz_id: exercise.shop_quiz_id,
      play_again: fromStart,
    } as QuizSessionAnswerRequest;
    this.shopQuizzesApiService.playShopQuizStatus(exercise.shop_quiz_id, params).subscribe((resp) => {
      this.quiz = resp;
      this.exercise = exercise;
      if (cb) cb();
      this.router.navigate([
        'course',
        this.schoolCoursesService.currentCourseId,
        'chapter',
        this.schoolCoursesService.currentChapterId,
        `lesson`,
        lessonId,
        exercise.shop_quiz_id,
      ]);
    });
  }

  submitAnswer(shop_quiz_id: string, lessonId: string, sessionAnswer: QuizSessionAnswerRequest) {
    this.shopQuizzesApiService.playShopQuizStatus(shop_quiz_id, sessionAnswer).subscribe((resp) => {
      this.quiz = { ...resp, question: this.quiz.question };

      this.router.navigate([
        'course',
        this.schoolCoursesService.currentCourseId,
        'chapter',
        this.schoolCoursesService.currentChapterId,
        'lesson',
        lessonId,
        shop_quiz_id,
      ]);
    });
  }
}
